import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';

interface DepositCheckoutProps {
  clientSecret: string;
  stripeAccountId: string;
}

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;

export function DepositCheckout({ clientSecret, stripeAccountId }: DepositCheckoutProps) {
  // stripeAccount must match the connected account that owns the CheckoutSession
  const stripePromise = useMemo(
    () => loadStripe(STRIPE_PUBLISHABLE_KEY!, { stripeAccount: stripeAccountId }),
    [stripeAccountId],
  );

  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
